import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { MaskLines, Reveal } from "./Motion";
import { QuoteForm } from "./QuoteForm";
import { SITE } from "@/lib/site";

export const QuoteSection = ({ defaultType = "", title }) => (
  <section id="devis" data-testid="quote-section" className="grain relative bg-ink px-5 py-24 text-paper sm:px-8 lg:py-32">
    <div className="relative mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <p className="eyebrow text-gold mb-6">Devis gratuit</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
          <MaskLines lines={title || ["Parlons de", <em key="e" className="text-gold">votre projet.</em>]} />
        </h2>
        <Reveal className="mt-10 space-y-5 text-paper/90">
          <a href={SITE.phoneHref} data-testid="quote-section-phone" className="flex items-center gap-4 font-display text-3xl hover:text-gold transition-colors duration-300"><Phone className="h-5 w-5 text-gold" />{SITE.phone}</a>
          <a href={`mailto:${SITE.email}`} className="flex items-center gap-4 text-sm"><Mail className="h-4 w-4 text-gold" />{SITE.email}</a>
          <p className="flex items-center gap-4 text-sm"><MapPin className="h-4 w-4 text-gold" />{SITE.address}</p>
          <p className="flex items-center gap-4 text-sm"><Clock className="h-4 w-4 text-gold" />{SITE.hours[0][0]} · {SITE.hours[0][1]}</p>
        </Reveal>
      </div>
      <div className="lg:col-span-8 border-t border-ink-line pt-10 lg:border-t-0 lg:border-l lg:pl-14 lg:pt-0">
        <QuoteForm dark defaultType={defaultType} />
      </div>
    </div>
  </section>
);
